import React from 'react';
import { useAppContext } from 'providers/AppProvider';

const NavbarDebug = () => {
  const { config } = useAppContext();
  
  // Force debug in production
  React.useEffect(() => {
    console.log('🔍 NAVBAR DEBUG - Current config:', {
      navbarPosition: config.navbarPosition,
      isNavbarVerticalCollapsed: config.isNavbarVerticalCollapsed,
      navbarTopShape: config.navbarTopShape,
      localStorage: {
        navbarPosition: localStorage.getItem('navbarPosition'),
        isNavbarVerticalCollapsed: localStorage.getItem('isNavbarVerticalCollapsed')
      }
    });
  }, [config]);

  return (
    <div style={{
      position: 'fixed',
      bottom: 20,
      right: 20,
      background: 'rgba(0,0,0,0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px'
    }}>
      <div style={{marginBottom: '5px'}}>
        <strong>Navbar Debug</strong>
      </div>
      <div>Position: <span style={{color: config.navbarPosition === 'vertical' ? '#4caf50' : '#f44336'}}>{config.navbarPosition}</span></div>
      <div>localStorage: {localStorage.getItem('navbarPosition')}</div>
      <button 
        onClick={() => {
          localStorage.setItem('navbarPosition', '"vertical"');
          localStorage.removeItem('isNavbarVerticalCollapsed');
          window.location.reload();
        }}
        style={{
          marginTop: '10px',
          padding: '5px 10px',
          background: '#4caf50',
          border: 'none',
          color: 'white',
          borderRadius: '3px',
          cursor: 'pointer'
        }}
      >
        Force Vertical & Reload
      </button>
    </div>
  );
};

export default NavbarDebug;